import React from "react";
import Typography from "@material-ui/core/Typography";
import {
  PASSWORD_STRENGTH_ERROR,
} from "../../tools/passwordValidation";

interface PasswordValidationErrorProps {
  error: string;
  errorListClassName?: string;
  typographyProps?: React.ComponentProps<typeof Typography>;
}

const PasswordValidationError = ({
  error,
  errorListClassName,
  typographyProps,
}: PasswordValidationErrorProps) => {
  if (error === PASSWORD_STRENGTH_ERROR) {
    return (
      <Typography color="error" component="div" {...typographyProps}>
        Le mot de passe doit :
        <ul className={errorListClassName}>
          <li>Faire au moins 8 caractères</li>
          <li>Contenir une lettre majuscule et une lettre minuscule</li>
          <li>Inclure au moins un chiffre</li>
          <li>
            Inclure un des caractères spéciaux suivants : !@#$%^&amp;*-_.
          </li>
        </ul>
      </Typography>
    );
  }

  return (
    <Typography color="error" {...typographyProps}>
      {error || ""}
    </Typography>
  );
};

export default PasswordValidationError;
